module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAABCAYAAADJsB7sAAAAAXNSR0IArs4c6QAAABBJREFUCB1jvHTn3n+GAQAApJQDjfjPiccAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./node_modules/loyal-design-system/assets/images/step-separator.png
// module id = 808
// module chunks = 14